import React from 'react';
import { TValue, TUpdatedValues } from '../components/types';
import { TextRow } from '../components/TextRow';
import { EditableDateRow } from '../components/EditableDateRow';
import { EditableRow } from '../components/EditableRow';
import { TYPEOF_STRING } from 'src/constants/utils/typeof';
import { SPECIAL_EDITABLE_FIELDS } from '../constants';

interface FactoryProps {
    item: TValue;
    loading: boolean;
    handleSave: (values: TUpdatedValues) => void;
    key: number;
}

/**
 * Factory to create the appropriate row component based on the field type
 * @param props - Properties required to render the row
 * @returns The appropriate row component
 */
export const tableRowLeadInfoFactory = ({
    item,
    loading,
    handleSave,
    key,
}: FactoryProps): React.ReactElement => {
    if (!item.editable) {
        return <TextRow key={key} item={item} loading={loading} />;
    }

    if (item.field === SPECIAL_EDITABLE_FIELDS.VEHICLE_DELIVERY_DATE) {
        return (
            <EditableDateRow
                key={key}
                item={item}
                loading={loading}
                handleSave={handleSave}
            />
        );
    }

    if (typeof item.text === TYPEOF_STRING) {
        return (
            <EditableRow
                key={key}
                item={item}
                loading={loading}
                handleSave={handleSave}
            />
        );
    }

    return <TextRow key={key} item={item} loading={loading} />;
};
